import { Box, Text } from '@cad-arc';
import { BoloQueueView, EventQueueWireDto } from '@mark43/cad-api';
import { observer } from 'mobx-react-lite';
import { PriorityBox } from '../common/components/fr-queues/priority-box';
import { useFrPriorityAppearance } from '../configurable-colors-sounds/priority-colors';

const PriorityChip = ({
    isPriority,
    label,
    flashColor,
    fill,
    text,
}: {
    isPriority: boolean;
    label?: string;
    flashColor?: string;
    fill?: string;
    text?: string;
}) => {
    return (
        <Box
            w={14}
            h="full"
            minH="85px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            borderRadius="base"
            flexShrink={0}
        >
            <PriorityBox isFlashing={isPriority} flashColor={flashColor} backgroundColor={fill}>
                <Text variant="headingLg" style={text ? { color: text } : undefined}>
                    {label}
                </Text>
            </PriorityBox>
        </Box>
    );
};

export const FrPriorityChip = observer(function FrPriorityChip({
    data,
}: {
    data: EventQueueWireDto;
}): React.ReactElement {
    const appearance = useFrPriorityAppearance(data);
    if (!data) {
        return <span />;
    }
    return (
        <PriorityChip
            isPriority={appearance.isFlashing}
            label={data.priority}
            flashColor={appearance.flashColor}
            fill={appearance.fill}
            text={appearance.text}
        />
    );
});

export function BoloQueuePriorityChip({ data }: { data: BoloQueueView }): React.ReactElement {
    if (!data) {
        return <span />;
    }
    return (
        <PriorityChip
            isPriority={data.priorityAbbreviation === 'P1'}
            label={data.priorityAbbreviation}
        />
    );
}
